module.exports = __webpack_public_path__ + "static/media/mobile-bg.eab41dd8.jpg";